module.exports = __webpack_public_path__ + "img/dialog-header-zh-cn.a730a6ea.png";